import svg from './row-svg/doc-integre.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function DocIntegreIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default DocIntegreIcon;
